import Corsi from 'images2/home-inclusione/Corsi.png';
import VoglioSapere from 'images2/inclusione/italiano_saperedipiù.png';
import { PAGE_COME_FUNZIONA_APPRENDIMENTO_LINGUA, PAGE_INCLUSIONE_CORSO_ITALIANO } from 'types/url';

export const title = 'APPRENDIMENTO \nDELLA LINGUA ITALIANA';
export const categories = [
  {
    link: PAGE_COME_FUNZIONA_APPRENDIMENTO_LINGUA,
    image: VoglioSapere,
    title: 'VOGLIO SAPERE\nDI PIù SUL SERVIZIO',
  },
  {
    link: PAGE_INCLUSIONE_CORSO_ITALIANO,
    image: Corsi,
    title: 'CERCO UN CORSO\nDI ITALIANO A MILANO',
  },
];
